import { $, _, Obscura, Backbone, Foundation, moment, Radio } from "../../../../vendor";

import { Notification, Biscuit, FormatHelper } from "../../../utils";
import InboomaBaseView from "../../InboomaBaseView";
import InboomaBaseCollectionView from "../../InboomaBaseCollectionView";

import Products from "../../../collections/Products";

import ProductsOverviewModalTpl from "../../../templates/orders/ReservationForm/ProductsOverviewModalTpl.html";
import ProductsOverviewItemTpl from "../../../templates/orders/ReservationForm/ProductsOverviewItemTpl.html";

const ProductsOverviewItemProductSelect = InboomaBaseView.extend({
  template: _.template(`
    `),

  templateContext() {
    return {};
  },

  initialize() {
    if (typeof this.model.attributes.warning !== "undefined") return;

    const that = this;
    // Set default state
    // These attributes will be reset in ProductOverviewList.initialize()
  },
});

const ProductsOverviewItem = InboomaBaseCollectionView.extend({
  // Intermediary class between productItem-frame
  // and select-boxes (= product amount's)

  template: ProductsOverviewItemTpl,
  childView: ProductsOverviewItemProductSelect,
  childViewContainer: ".products-overview-item__checkbox",
  className: "small-9 medium-3 column products-overview-item-wrapper fifty_percent",

  ui: {
    chosenProductInput: ".normal-product",
    changedText: ".free-text",
  },

  events: {
    "click @ui.chosenProductInput": "_updateChosenProduct",
    "input @ui.changedText": "_updateChangedProduct",
  },

  templateContext() {
    return {
      product: _.first(this.collection.models),
      warning: this._warning,
      t: this.t,
    };
  },

  _onChangeWarning() {
    let warning = null;

    _.each(this.collection.models, function (product) {
      if (product.get("warning") !== null) {
        warning = product.get("warning");
      }
    });

    if (this._warning !== warning) {
      this._warning = warning;
      this.render();
    }
  },

  _updateChangedProduct() {
    const parentId = "#parent_check_" + this.model.get("id");
    let chosenProduct = null;
    if (this._warning === null && this.getUI("changedText").val().trim().length > 0) {
      if (!$(parentId).hasClass("activated")) {
        $(parentId).addClass("activated");
      }

      chosenProduct = this.getUI("changedText").val();
    } else {
      $(parentId).removeClass("activated");
    }

    if (chosenProduct !== null) {
      this.model.set("warning", null);
      if (chosenProduct !== this.model.attributes.product.original) {
        this.model.set("_name", chosenProduct);
        this.model.attributes.product.chosen = chosenProduct;
        this.model.attributes.product._name = chosenProduct;
        this.options.futureParentModifierProduct.set(
          this.model.get("id").toString(),
          this.model.attributes.product.chosen,
        );
      }
      //this.render();

      this.model.trigger("changedWarning");
    }
  },

  _updateChosenProduct() {
    let chosenProduct = null;
    if (!this.getUI("chosenProductInput").hasClass("activated") && this._warning === null) {
      this.getUI("chosenProductInput").addClass("activated");
    } else {
      this.getUI("chosenProductInput").removeClass("activated");
    }
    if (this.model.get("type") === "free") {
      if (
        $("#text_" + this.model.get("id"))
          .val()
          .trim().length < 1
      ) {
        this.model.set("warning", "no_text_is_entered");

        this.model.trigger("changedWarning");
      } else {
        chosenProduct = $("#text_" + this.model.get("id")).val();
        this.model.set("_name", chosenProduct);
        this.model.attributes.product._name = this.model.attributes.product.name = $(
          "#text_" + this.model.get("id"),
        ).val();
      }
    } else {
      chosenProduct = this.getUI("chosenProductInput").hasClass("activated");
    }

    if (chosenProduct !== null) {
      this.model.set("warning", null);
      this.model.set("_name", chosenProduct);
      this.model.attributes.product.chosen = chosenProduct;
      this.model.attributes.product._name = chosenProduct;
      this.options.futureParentModifierProduct.set(
        this.model.get("id"),
        this.model.attributes.product.chosen,
      );

      if (this.model.attributes.product.chosen < this.model.attributes.product.original) {
        if (this.model.attributes.product.original !== "") {
          this.model.set("warning", "action_conflict_less_selected_than_before");
        }
      }
      //this.render();

      this.model.trigger("changedWarning");
    }
  },

  initialize() {
    const that = this;

    this.model.set({
      product: {
        chosen: false,
        original: false,
      },
      warning: null, // UI-indicator
      _name: null,
    });

    _.each(this.options.selectedReservationProducts, function (product) {
      // Map actual product ("original") selections from ReservationsList into model
      if (product.where({ productId: that.model.get("id") }).length) {
        if (that.model.get("type") === "free") {
          that.model.attributes.product._name = product.where({
            productId: that.model.get("id"),
          })[0].attributes.description;
          that.model.attributes.product.chosen = product.where({
            productId: that.model.get("id"),
          })[0].attributes.description;
          that.model.attributes.product.original = product.where({
            productId: that.model.get("id"),
          })[0].attributes.description;
        } else {
          that.model.attributes.product.chosen = product.length;
          that.model.attributes.product.original = that.model.attributes.product.chosen;
        }
      }
    });

    // However, if initalize() was only called as part of a re-render,
    // use its old state

    let chosen = this.options.futureParentModifierProduct.get(this.model.get("id"));

    if (typeof chosen !== "undefined") {
      this.model.attributes.product.chosen = chosen;
    }
    this._warning = null;

    this.collection = new Backbone.Collection();
    const _model = that.collection.add(this.model);

    // As this is runtime we need to set modelEvents manually:
    _model._rbac = {};
    _model.on("changedWarning", () => that._onChangeWarning());

    // this.render();
  },
});

/**
 * Fetch available product-ids & -numbers by begin_location
 *
 * @param {String} contingentIds
 * @param {function} callback
 * @param errorCallback
 */
const GetProductsAvailable = (contingentIds, callback, errorCallback = _.noop) => {
  const RequestHelper = Backbone.Model.extend({
    url: "/products/getRelatedProducts/" + contingentIds,
  });

  const requestHelper = new RequestHelper().fetch({
    success(model, response) {
      callback(response.related_products);
    },
    error() {
      errorCallback();
    },
  });
};

export default InboomaBaseCollectionView.extend({
  el: "#contingents-overview-modal",
  childView: ProductsOverviewItem,
  childViewContainer: "#products-overview__list",
  template: ProductsOverviewModalTpl,

  templateContext() {
    return {
      t: this.t,
    };
  },

  childViewOptions() {
    return {
      selectedReservationProducts: this.options.parentReservation.model.get("summedProducts"),
      futureParentModifierProduct: this.futureParentModifierProduct,
    };
  },

  ui: {
    saveBtn: "#products-overview__save",
    closeBtn: "#products-overview__close",
    searchField: "#products-overview__search input",
  },

  events: {
    "click @ui.saveBtn": "_saveProductsToReservation",
    "click @ui.closeBtn": "_closeWindow",
    "keyup @ui.searchField": "_filterCollectionByQuery",
  },

  _closeWindow() {
    this._allowClose = true;

    if (typeof this.modal !== "undefined") {
      this.modal.close();
    } else {
      this._close();
    }
  },

  _close() {
    if (this._allowClose) {
      this.unbind();
      this.undelegateEvents();
      this.unbindEvents();
      this.unbindUIElements();
      this.$el.off("closed.zf.reveal");
      delete this.futureParentModifierProduct;
      //  delete that.modal;
    } else {
      this.modal.open();
    }
  },

  initialize() {
    this._allowClose = false;

    const that = this;

    this.$el.on("closed.zf.reveal", () => {
      that._close();
    });

    this.collection = new Backbone.Collection();
    this.Products = new Products();
    let contingentIds = "";
    if (that.options.default == true) {
      contingentIds = that.options.contingent_id;
    } else {
      let dynamoContingents = null;
      const locations = Radio.channel("dynamo_start_locations").request("get:data");
      let beginLocation = locations.find({
        begin_location_id: Number(that.options.begin_location.get("begin_location_id")),
      });

      if (typeof beginLocation == "undefined") {
        beginLocation = locations.find({
          location_id: Number(that.options.begin_location.get("location_id")),
        });
        this.options.beginLoc = this.options.begin_location.get("location_id");
        dynamoContingents = beginLocation.attributes.contingents;
      } else {
        this.options.beginLoc = Number(this.options.begin_location.get("begin_location_id"));
        dynamoContingents =
          beginLocation.attributes.end_locations[that.options.end_location.get("begin_location_id")]
            .contingents;
      }

      _.each(dynamoContingents, function (_contingents, _contingent_name) {
        _.each(_contingents, function (__contingent, __contingent_id) {
          if (contingentIds === "") {
            contingentIds = __contingent_id;
          } else {
            contingentIds += "," + __contingent_id;
          }
        });
      });
    }
    that.baseCollection = that.collection.clone();
    GetProductsAvailable(
      contingentIds,
      (products) => {
        let c = 0;

        const _checkForCollectionIterationComplete = () => {
          // Similar to dependencies.js we ensure that (a)sync calls
          // to collection.add have been finalized, then render()
          if (++c == _.size(products)) {
            const filterableCollection = that.collection.clone();
            that.collection = new Obscura(filterableCollection);
            const filterableCollection2 = that.baseCollection.clone();
            that.baseCollection = new Obscura(filterableCollection2);
            that.modal = new Foundation.Reveal(this.$el, {
              closeOnEsc: false,
              closeOnClick: false,
              multipleOpened: true,
            });

            InboomaBaseCollectionView.prototype.initialize.apply(that);

            that.render();

            // Problem on re-rendering: Old animation transition attr still existent
            // this refs #19930
            that.$el.attr("class", "reveal large");

            that.modal.open();
          }
        };

        // --- Let's start!
        let count = 0;
        let groupedProducts = {};
        _.each(products, (product) => {
          if (product === []) {
            _checkForCollectionIterationComplete();
            return;
          }

          let productInList = that.Products.get(Number(product.id));

          if (typeof productInList == "undefined") {
            // Product not yet in one of the previously scanned groups
            that.Products.add(product);

            groupedProducts[product.id] = product;
            that.collection.add([product]);

            count++;
          }
          that.baseCollection.add([groupedProducts]);

          // 'r we done yet?
          _checkForCollectionIterationComplete();
        });
      },
      () => {
        // Error callback

        new Notification({
          message: that.t("no_products_available"),
          duration: 5000,
          type: "warning",
          closeable: true,
          icon: "fi fi-x",
        });

        that._allowClose = true;
        that._closeWindow();
      },
    );
    // On init:
    // Unset internally required data to enforce re-setting
    // amount-data (see ProductsOverviewItem.initialize)
    //_.each(this.collection.models, function (model) {
    // _.each(this.Products.models, function (model) {

    //  delete model.attributes.amount;
    //   delete model.attributes.selected;

    //});

    // In this.futureParentModifier sub-views can set changes on the actual
    // products selecton. New, updated or removed elements
    // will be added added, updated or removed by parent reservation
    this.futureParentModifierProduct = new Backbone.Model();

    this.futureParentModifierProduct.on("change remove", (model) => {
      that._markSaveBtnAsComplete();
    });
  },

  _filterCollectionByQuery() {
    const query = this.getUI("searchField").val().toLowerCase();

    this.getUI("searchField").parent().find(".inb-input--search-reset").fadeIn("fast");

    if (query.length >= 2) {
      this.collection.filterBy("query", (productGroup) => {
        const _product = productGroup.attributes[Object.keys(productGroup.attributes)[0]];
        return _product.name.toLowerCase().indexOf(query) >= 0;
      });
    } else if (query.length <= 1) {
      this.collection.removeFilter("query");
    }
  },

  _markSaveBtnAsUncomplete() {
    const saveBtn = this.$el.find(this.ui["saveBtn"]);

    saveBtn
      .removeClass("beautify")
      .removeClass("beautify-" + Biscuit.get("user.client_id"))
      .addClass("hollow");
  },

  _markSaveBtnAsComplete() {
    const saveBtn = this.$el.find(this.ui["saveBtn"]);

    saveBtn
      .removeClass("hollow")
      .addClass("beautify")
      .addClass("beautify-" + Biscuit.get("user.client_id"));
  },

  _saveProductsToReservation() {
    // Finally compare local selection with original collection,
    // then modify the latter one

    let added = 0,
      deleted = 0;

    const that = this;

    _.each(
      this.options.parentReservation.model.get("summedProducts"),
      function (collection, productId) {
        // -- Option I --
        // Modify the numbers of a product that has already
        // been selected in ReservationProductsList
        const soll = that.futureParentModifierProduct.get(productId);

        if (typeof soll !== "undefined") {
          if (soll == false) {
            // -- Option I.I --
            // Unset original product completely
            deleted++;
            delete that.options.parentReservation.model.attributes.summedProducts[productId];
            that.options.parentReservation.model.trigger("removedProduct", productId);
            delete that.futureParentModifierProduct.attributes[productId];
          }
        }
      },
    );

    let summedProducts = that.options.parentReservation.model.get("summedProducts");

    _.each(this.futureParentModifierProduct.attributes, function (value, productId) {
      // -- Option II --
      // Product was selected that is not yet in scope of reservation
      if (productId.includes("_")) {
        let help = productId.split("_");
        productId = help[0];
      }

      let product = that.Products.get(productId);
      if (product.attributes.type === "free" && typeof summedProducts[product.id] == "undefined") {
        product.attributes.description = value;
      }
      product.attributes.manual_override = false;

      if (typeof summedProducts[product.id] == "undefined") {
        summedProducts[product.id] = new Products(product);
      } /*else {
                // Clone product WITHOUT previous id, WITHOUT reference
                const clone = product.clone();
                clone.set('baseContingentId',clone.id); // @todo Put EITHER here OR in ReservationContingentsList
                if(clone.attributes.type === 'free'){
                    clone.attributes.description = value;
                }
                delete clone.attributes.id;
            
                summedProducts[product.id].add(clone, { trigger:false });
            }*/
      added++;

      that.options.parentReservation.model.set("summedProducts", summedProducts);
      that.options.parentReservation.model.trigger("change:summedContingents");
    });

    let message = added >= 1 ? this.t("${a}_products_added", { a: added }) + "\n" : "";
    message += deleted >= 1 ? this.t("${a}_products_deleted", { a: deleted }) + "\n" : "";

    if (message !== "") {
      new Notification({
        message,
        duration: 5000,
        closeable: true,
        icon: "fi fi-check",
      });

      this.options.parentReservation.onChangeObserver.call(this.options.parentReservation);
    }

    this._allowClose = true;
    this.modal.close();
  },
});
